import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { ScarcityBar } from './ScarcityBar';
import { Wordmark } from './Wordmark';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-14 sm:px-6 sm:py-20" data-id="element-112" data-mp="19g0cphlqnujw">
      <div className="mx-auto max-w-2xl text-center" data-id="element-113" data-mp="15dltgwe5qss3">
        <h2 className="font-serif text-[27px] font-bold leading-[1.14] text-cream sm:text-[38px]" data-id="element-114" data-mp="15c2dz80bslrd">
          Your next patient isn’t waiting for you to remember every guideline.
        </h2>
        <p className="mt-5 text-[16px] leading-relaxed text-cream/70 sm:text-[17px]" data-id="element-115" data-mp="1ediorgv1ypw4">
          She needs you to have a structured way to navigate the information that matters. You don’t need
          another massive library — you need a better way to find the pathway you’re looking for.
        </p>

        <div className="mt-9 rounded-3xl border border-gold/40 bg-white/[0.06] p-5 sm:p-8" data-id="element-116" data-mp="2245x238vrhj7">
          <Wordmark tone="light" data-id="element-117" data-mp="1x64h3r6r3yby" />
          <p className="mt-4 font-serif text-[18px] font-semibold italic leading-snug text-gold-light sm:text-xl" data-id="element-118" data-mp="1x2p0gjxfih8f">
            Find the clinical pathway you need in 5 minutes or less.
          </p>
          <p className="mt-3 text-[12px] font-bold uppercase tracking-[0.12em] text-cream/60" data-id="element-119" data-mp="s6ijx7hdt4kh">
            6 tomes + 5 premium bonuses
          </p>

          <p className="mt-5 font-serif text-[56px] font-bold leading-none text-cream sm:text-6xl" data-id="element-120" data-mp="123wmq4adtuub">$27</p>
          <p className="mt-1 text-[12.5px] font-bold uppercase tracking-[0.12em] text-cream/60" data-id="element-121" data-mp="163ozyuaq0p60">
            USD · one-time payment
          </p>

          <div className="mt-6" data-id="element-122" data-mp="1fu9x0daqxlmt">
            <CtaButton label="Get access for $27 USD" variant="gold" note="One-time payment · Instant digital access · 7-day guarantee · Currency converted automatically" data-id="element-123" data-mp="1fu05umdyt8fj" />
          </div>

          <div className="mt-6" data-id="element-124" data-mp="1pqcx7dm1fa74">
            <CountdownTimer data-id="element-125" data-mp="1ttrpb2n93h0x" />
          </div>

          <div className="mt-7 text-left" data-id="element-126" data-mp="1tuknvgc2307z">
            <ScarcityBar data-id="element-127" data-mp="3quoxkvn10vpe" />
          </div>
        </div>
      </div>
    </section>;
}